import React from 'react'
import classNames from 'classnames'
import { Tree } from 'antd'

import styles from './styles.module.scss'

import type { ReactElement } from 'react'
import type { LntTreeDataNode, LntTreeProps } from './types'

export const LntTree = <TreeDataNodeType extends LntTreeDataNode = LntTreeDataNode>({
  className: outerClassName,
  ...restProps
}: LntTreeProps<TreeDataNodeType>): ReactElement<LntTreeProps<TreeDataNodeType>> => {
  const className = classNames(styles.lntTree, outerClassName)

  return (
    <Tree
      { ...restProps }
      className={ className }
    />
  )
}
